import { type FC } from 'react';
import classNames from 'classnames';
import dibsCss from 'dibs-css';

import styles from './SellerReviewInformationLoading.scss';

export const SellerReviewInformationLoadingSection: FC = () => {
    return (
        <div
            className={classNames(dibsCss.flex, dibsCss.flexCol, dibsCss.gapMedium, dibsCss.wFull)}
        >
            <div
                className={classNames(
                    styles.shimmer,
                    dibsCss.h20px,
                    dibsCss.w200px,
                    dibsCss.roundedXxsmall
                )}
            />

            <div
                className={classNames(styles.shimmer, dibsCss.h16px, dibsCss.roundedXxsmall)}
                style={{ width: 280 }}
            />

            {[0, 1, 2].map(i => (
                <div
                    key={i}
                    className={classNames(
                        dibsCss.flex,
                        dibsCss.itemsStart,
                        dibsCss.justifyBetween,
                        dibsCss.gapLarge,
                        dibsCss.pbMedium,
                        i !== 2 && dibsCss.borderB,
                        i !== 2 && dibsCss.borderBSolid,
                        i !== 2 && dibsCss.borderBDolphin
                    )}
                >
                    <div className={classNames(dibsCss.flexGrow, dibsCss.minW0)}>
                        <div
                            className={classNames(
                                styles.shimmer,
                                dibsCss.h16px,
                                dibsCss.w200px,
                                dibsCss.roundedXxsmall,
                                dibsCss.mbXsmall
                            )}
                        />
                        <div
                            className={classNames(
                                styles.shimmer,
                                dibsCss.wFull,
                                dibsCss.roundedXxsmall
                            )}
                            style={{ height: 72 }}
                        />
                    </div>

                    <div className={dibsCss.flexNone}>
                        <div
                            className={classNames(styles.shimmer, dibsCss.roundedXxsmall)}
                            style={{ width: 80, height: 80 }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export const SellerReviewInformationLoading: FC = () => {
    return (
        <section className={classNames(dibsCss.mtMedium, dibsCss.mbMedium)}>
            <div className={classNames(dibsCss.flex, dibsCss.gapLarger, dibsCss.itemsStart)}>
                <div
                    className={classNames(
                        dibsCss.flex,
                        dibsCss.flexCol,
                        dibsCss.w400px,
                        dibsCss.minW400px,
                        dibsCss.gapSmall
                    )}
                >
                    <div
                        className={classNames(
                            styles.shimmer,
                            dibsCss.h20px,
                            dibsCss.w200px,
                            dibsCss.roundedXxsmall
                        )}
                    />

                    <div
                        className={classNames(
                            styles.shimmer,
                            dibsCss.wFull,
                            dibsCss.roundedXxsmall
                        )}
                        style={{ height: 360 }}
                    />

                    <div
                        className={classNames(
                            styles.shimmer,
                            dibsCss.h16px,
                            dibsCss.w200px,
                            dibsCss.roundedXxsmall
                        )}
                    />
                </div>

                <div className={classNames(dibsCss.selfStretch, dibsCss.flex, dibsCss.itemsCenter)}>
                    <div className={classNames(dibsCss.w1px, dibsCss.hFull, dibsCss.bgDolphin)} />
                </div>

                <SellerReviewInformationLoadingSection />
            </div>
        </section>
    );
};
